import React from 'react';

function Footer(): JSX.Element {
  return (
    <footer className="min-h-full py-8 text-sm text-gray-500 text-center sm:text-left">
      &copy; 2021{' '}
      <a href="https://hugmanrique.me" className="hover:text-gray-700">
        Hugo Manrique
      </a>
    </footer>
  );
}

export default React.memo(Footer);
